import { AppState } from '../../bootstrap/redux/state/AppState';
import { ISpaceInfoTypeItemCount, SpaceInfoTypeContentCounts } from '../state/ContentCountsState';
import { SpaceType } from '../state/SpaceInfo';

export interface ContentCountsProps {
  contentCounts: SpaceInfoTypeContentCounts;
}

export function selectContentCounts<T extends SpaceType>(state: AppState, spaceType: SpaceType): ISpaceInfoTypeItemCount<T> {
  return state.contentExplorer.contentCounts.counts[spaceType] as ISpaceInfoTypeItemCount<T>;
}

export function selectContentCountsUpToDate(state: AppState): boolean {
  return state.contentExplorer.contentCounts.isUpToDate;
}

